module.exports = __webpack_public_path__ + "static/media/A-BTN.54d76f24.png";